import styled from 'styled-components';

import { ButtonV2 } from '@getgrover/ui';
import { SubHeadline, Paragraph } from 'ggApp/shared/common/Typography';

export const Home = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const List = styled.div`
    flex-grow: 1;
`;

export const ListItem = styled.div``;

export const Title = styled(SubHeadline)``;

export const SubTitle = styled(Paragraph)`
    margin: 8px 0;
    color: ${({ theme }) => theme.colors['Level 5']};
`;

export const Btns = styled.div`
    display: flex;
    margin-top: 8px;

    > *:not(:only-child) {
        &:first-child {
            margin-right: 8px;
            min-width: 120px;
        }
    }
`;

export const Btn = styled(ButtonV2)`
    margin: 16px 0 0;
`;
